module.exports = __webpack_public_path__ + "img/C05TechAuxiliaCamp_Upgrade2_ua.5cefae6d.webp";